// MVP Navigation items - only working features
import { 
  LayoutDashboard, 
  Heart, 
  Stethoscope, 
  Utensils, 
  Calendar, 
  BookOpen, 
  ShoppingCart, 
  Pill,
  Settings,
  Info
} from 'lucide-react';

export const exampleNavigationItems = {
  baseItems: [
    { id: 'dashboard', icon: LayoutDashboard, label: 'Dashboard' },
    { id: 'conditions', icon: Heart, label: 'Conditions' },
  ],
  symptomItems: [
    { id: 'symptoms', icon: Stethoscope, label: 'Symptoms' },
  ],
  nutritionItems: [
    { id: 'enhanced-food-tracker', icon: Utensils, label: 'Food Tracker', featured: true },
    { id: 'meal-log', icon: Calendar, label: 'Meal Logger', featured: true },
  ],
  medicationItems: [
    { id: 'medications', icon: Pill, label: 'Medications' },
  ],
  systemItems: [
    { id: 'settings', icon: Settings, label: 'Settings' },
  ],
  infoItems: [
    { id: 'about', icon: Info, label: 'About' },
  ],
  // MVP: Removed all beta and broken features
  guruItems: [],
  dataItems: [],
  coreItems: [],
  advancedItems: [],
  adminItems: []
}; 